import { makeStyles } from "@mui/styles";
import { rem, goMegaMall } from "assets/js/common";
import { Button } from "@mui/material";
import { useHistory, useLocation, withRouter, Prompt } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { dropByCacheKey } from "react-router-cache-route";
import { Link } from "react-router-dom";
import AlertConfirm from "./alert-confirm";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { setBottomColor, openMagamartMall } from "assets/js/apphandle";
import { Cookies } from "react-cookie";
import { goLink } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAlert, loadAppCard, loadHideAlert } from "redux/reducers/top";

const useStyles = makeStyles((theme) => ({
  bottom: {
    display: "flex",
    justifyContent: "space-between",
    height: "100%",
    padding: `${rem(13)} ${rem(22)} ${rem(18)}`,
    "& .MuiButton-root": {
      marginLeft: rem(15),
      "& + .text-btn, + .MuiButton-root": {
        marginLeft: rem(15),
      },
    },
    "& .active-menu": {
      opacity: "1 !important",
    },
    "& .text-btn": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      opacity: 0.7,
      minWidth: "auto",
      width: "100%",
      height: rem(41),
      "& span": {
        color: "#FFFFFF",
        fontSize: rem(12),
        paddingTop: rem(5),
        lineHeight: rem(12),
        letterSpacing: "-0.3px",
      },
    },

    "& .barcode-btn": {
      minWidth: rem(54),
      minHeight: rem(54),
      opacity: 1,
      backgroundColor: "#FFFFFF",
      borderRadius: "50%",
      marginTop: rem(-5),
      marginLeft: rem(15),
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
  },
}));

export default function Bottom(props) {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  let currentPath = useLocation();
  const classes = useStyles();
  const history = useHistory();
  const [token, setToken] = useState("");

  const goPage = (path) => {
    if (token) {
      dropByCacheKey(location.pathname);
      history.push(path);
    } else {
      dispatch(loadAlert(true));
    }
  };

  const checkAuth = () => {
    if (token) {
      dispatch(loadAppCard(true));
    } else {
      dispatch(loadAlert(true));
    }
  };

  useEffect(() => {
    setToken(cookies.get("X-AUTH-TOKEN"));
  }, []);

  return (
    <div className={classes.bottom}>
      <Link
        to={"/"}
        onClick={() => (window.location.href = "/")}
        className="text-btn active-menu"
      >
        <LazyCDNImage
          cdnUrl={`${process.env.PUBLIC_URL}/images/icon/menu_home_active.svg`}
        />
        <span>홈</span>
      </Link>
      {/* <Button className="text-btn active-menu">
        <LazyCDNImage
          cdnUrl={`${process.env.PUBLIC_URL}/images/icon/menu_home_active.svg`}
        />
        <span>홈</span>
      </Button> */}
      <Button
        onClick={() => {
          goPage("/receipt");
        }}
        className="text-btn"
      >
        <LazyCDNImage
          cdnUrl={`${process.env.PUBLIC_URL}/images/icon/menu_receipt.svg`}
        />
        <span>영수증</span>
      </Button>
      <Button className="barcode-btn" onClick={checkAuth}>
        <img src={`${process.env.PUBLIC_URL}/images/icon/menu_barcode.svg`} />
      </Button>
      <Button
        onClick={() => {
          goPage("/coupon");
        }}
        className="text-btn"
      >
        <LazyCDNImage
          cdnUrl={`${process.env.PUBLIC_URL}/images/icon/menu_coupon.svg`}
        />
        <span>쿠폰</span>
      </Button>
      <Button
        onClick={() => {
          openMagamartMall();
        }}
        className="text-btn"
      >
        <LazyCDNImage
          cdnUrl={`${process.env.PUBLIC_URL}/images/icon/menu_mall.svg`}
        />
        <span>온라인몰</span>
      </Button>
    </div>
  );
}
